import axios, { AxiosInstance } from 'axios';

const api: AxiosInstance = axios.create({
  baseURL: '/',
  headers: {
    Accept: 'application/json',
  },
});

api.interceptors.response.use(
  response => {
    if (response.data?.error === true) {
      if (response.data.errorReason === 'UNAUTHORIZED') {
        console.log('User not logged in. Redirecting to login.');
        window.location.href = '/login';
      }

      const err = new Error(response.data.errorReason);
      (err as any).config = response.config;
      throw err;
    }
    return response;
  },
  error => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default api;
